import React, { createContext, useContext } from 'react';
import { useLocation } from 'react-router-dom';

export const PublicPageDataContext = createContext(null);
let browserData;

export function usePublicPageData() {
  const provided = useContext(PublicPageDataContext);
  const { pathname } = useLocation();
  if (typeof document !== 'undefined' && browserData === undefined) {
    const source = document.getElementById('jvc-public-data');
    try { browserData = source ? JSON.parse(source.textContent) : null; }
    catch { browserData = null; }
  }
  const data = provided || browserData;
  return data?.pathname === pathname ? data : null;
}
